import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "excelImportFormIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.excelImportFormIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.excelImportFormIsOpen = false;
    },
    setExcelImportFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.excelImportFormIsOpen = true;
    },
    setExcelImportFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.excelImportFormIsOpen = false;
    }
}
